import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { SpoteeMap } from './components/Map';

import './custom.css'

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Route exact path='/' component={() => window.location = 'http://www.spotee.net'} />
                <Route path='/:id' component={SpoteeMap} />
            </Layout>
        );
    }
}
